import { ReactElement } from 'react';

import { getAccessToken } from '../libs/accessToken';
import { getLayout as getBaseLayout } from './Layout';

type Props = {
  children: ReactElement | JSX.Element[];
};
const LayoutParallax: React.FC<Props> = ({ children }) => <main id="main-content">{children}</main>;

export const getLayout = (page) =>
  getBaseLayout(<LayoutParallax>{page}</LayoutParallax>, false, getAccessToken() !== undefined);

export default LayoutParallax;
